import React from 'react';
import { Image } from 'lightbox.js-react'
import 'lightbox.js-react/dist/index.css'
const GalleryItem = ({ imgSrc, altText }) => (
    <div className="col-xs-12 col-sm-4 col-md-3">
        <div className="mediaGallary">
            <Image image={{ src: imgSrc, title: altText }} />
        </div>
    </div>
);

const Gallery = ({ items }) => (
    <div role="tabpanel" className="tab-pane">
        <div className="row">
            {items.map((item, index) => (
                <GalleryItem key={index} imgSrc={item.imgSrc} altText={item.altText} />
            ))}
        </div>
    </div>
);

export default Gallery;